<template>
  <div id="app">
    <Navbar />

    <Alert />

    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Alert from "./components/Alert";
import Navbar from "./components/Navbar";
import { mapState, mapActions } from "vuex";

export default {
  name: "App",
  components: {
    Alert,
    Navbar
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      app: state => state.app
    })
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear"
    })
  }
};
</script>

<style scoped>
main {
  margin-top: 20px;
}
</style>

<style>
.mu-text-field-input {
  text-align: center;
}
.flex-wrapper {
  width: 100%;
  margin-top: 8px;
}
.flex-wrapper:first-child {
  margin-top: 0;
}
.w-25 {
  width: 25px;
}
.w-100 {
  width: 100%;
}
.p-20 {
  padding: 20px;
}
.m-8 {
  margin: 0 8px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-50 {
  margin-top: 50px;
}
.mw-600 {
  max-width: 600px;
}
#nprogress .bar {
  background: #fd6a02;
  height: 3px;
}
#nprogress .spinner {
  display: none;
}
</style>
